import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title", "aria-label"]

import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type scrollTopButtonProps = {
	enabled: boolean;
}

type scrollTopButtonEmit = {
	"on-click": [];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppScrollTopButton',
  props: {
    enabled: { type: Boolean, default: false }
  },
  emits: ["on-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass({
			'app-scroll-top': true,
			'app-scroll-top--enabled': props.enabled
		}),
    type: "button",
    title: _ctx.$t('ui_scroll_top'),
    "aria-label": _ctx.$t('ui_scroll_top'),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('on-click')))
  }, [
    _createVNode(AppIcon, {
      name: "arrow-up",
      width: "24px",
      color: "#fff"
    })
  ], 10, _hoisted_1))
}
}

})